/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsLogoList = {
  init: function($section) {

    console.log('jsLogoList called');

    // Add settings from schema to current object
    window.PXUTheme.jsLogoList = $.extend(this, window.PXUTheme.getSectionData($section));

    if(this.logo_style == 'slider') {
      this.createSlider();
    }


  },
  createSlider: function() {
    let logoListCarousel = $('.logo-list__carousel');
    $(logoListCarousel).flickity({
      lazyLoad: 2,
      freeScroll: false,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'left',
      wrapAround: false,
      pageDots: false,
      contain: true,
      watchCSS: true,
      //prevNextButtons: this.products_limit > this.products_per ? true : false,
      prevNextButtons: true,
      initialIndex: 0,
      arrowShape: arrowShape,
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          $(logoListCarousel).on( 'settle.flickity', function() {
            $(logoListCarousel).flickity('resize')
          });
        }
      }
    });

  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;